import { Component } from "@angular/core";

@Component({
  selector: "jni-refresh",
  templateUrl: "./refresh.component.html",
  styleUrls: ["./refresh.component.scss"],
})
export class RefreshComponent {
  //ToDO If implementation required
}
